import { Deserializable } from './deserializable.model';

export class Arquivo implements Deserializable {
  id = '';
  nome = '';
  descricao = '';
  ativo = false;
  anexo: any = null;

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
}
